import Vue from 'vue'
import Vuex from 'vuex'
import { getUserSessions } from '@/api/chatrecords'
const { getAuthMode, getSessionOwnerParams, getStoredGuestSessionId } = require('@/utils/auth')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    historylist: [],
    cate_id: null,
    historydetails: [],
    now_record_id: localStorage.getItem('currentSessionId') || null,
    user_id: localStorage.getItem('user_id') || null,
    auth_mode: getAuthMode() || null,
    guest_session_id: getStoredGuestSessionId() || null
  },
  getters: {},
  mutations: {
    set_new_id(state, id) {
      state.now_record_id = id
      if (id) {
        localStorage.setItem('currentSessionId', id)
      } else {
        localStorage.removeItem('currentSessionId')
      }
    },
    SET_CATE_ID(state, cateId) {
      state.cate_id = cateId
    },
    SET_HISTORY_LIST(state, historyList) {
      state.historylist = historyList
    },
    SET_HISTORY_DETAILS(state, historyDetails) {
      state.historydetails = historyDetails
    },
    SET_USER_ID(state, userId) {
      state.user_id = userId
      state.auth_mode = 'registered'
      state.guest_session_id = null
      if (userId) {
        localStorage.setItem('user_id', userId)
      } else {
        localStorage.removeItem('user_id')
      }
    },
    SET_GUEST_SESSION(state, guestSessionId) {
      state.guest_session_id = guestSessionId
      state.auth_mode = 'guest'
      state.user_id = null
      if (guestSessionId) {
        localStorage.setItem('guest_session_id', guestSessionId)
      } else {
        localStorage.removeItem('guest_session_id')
      }
      localStorage.removeItem('user_id')
    },
    CLEAR_AUTH_STATE(state) {
      state.user_id = null
      state.auth_mode = null
      state.guest_session_id = null
      state.now_record_id = null
      state.historydetails = []
    },
    DELETE_SESSION(state, sessionId) {
      state.historydetails = state.historydetails.filter(session => session.session_id !== sessionId)
      if (state.now_record_id === sessionId) {
        state.now_record_id = null
        localStorage.removeItem('currentSessionId')
      }
    }
  },
  actions: {
    async fetchUserSessions({ commit }) {
      const ownerParams = getSessionOwnerParams()
      if (!ownerParams.user_id && !ownerParams.guest_session_id) {
        return []
      }

      try {
        const response = await getUserSessions(ownerParams)
        if (response && response.data && response.data.code === 200 && response.data.sessions) {
          const sessions = response.data.sessions.map(session => ({
            ...session,
            session_id: session.session_id || session.id || null,
            session_title: session.session_title || '未命名会话'
          }))
          commit('SET_HISTORY_DETAILS', sessions)
          return sessions
        }
        console.error('Failed to fetch user sessions:', response)
        return []
      } catch (error) {
        console.error('Error fetching user sessions:', error)
        return []
      }
    },
    async deleteSession({ commit }, sessionId) {
      try {
        commit('DELETE_SESSION', sessionId)
        return true
      } catch (error) {
        console.error('Error deleting session:', error)
        return false
      }
    },
    refreshSessions({ dispatch }) {
      dispatch('fetchUserSessions')
    }
  },
  modules: {}
})
